import React, { useState } from 'react';
import './gallerymenu.css';
import { Link } from 'react-router-dom';
//import logo from 'https://ucarecdn.com/ebf43df5-eac6-4844-8271-ddd87ae637a4/-/preview/500x500/-/quality/smart/-/format/auto/'; // Replace with your actual logo image URL
        
        
function Gallerymenu() {
    //dashboardlibadminmenu
    const [showGerne, setShowGerne] = useState(false);

    const toggleMenu = () => {
        setShowGerne(!showGerne);
    };

    //const booktype = "physical";

  
  return (
    <>
       <div className="majoreventsmenu"> 
            <div className="majoreventsmenugerne">
                {showGerne ?
                <h2 onClick={toggleMenu}>Gallery Menu  &times;</h2>
                :
                <h2 onClick={toggleMenu}>Gallery Menu  &#9776;</h2>
                }
                <div className={`majoreventsmenugerneblock ${showGerne ? 'majoreventsmenushow-gerne' : ''}`}>
                    <div className="majoreventsmenuactualgerne">
                        <Link 
                            to="/gallery" 
                            //onClick={() => {if (window.location.href === 'http://localhost:3000/onlinecategory') {window.location.reload()} }}
                            state = {{
                                data: { majorevents: "all" , abt: ""}  // your data array of objects type.title {setIntquiz({quiznumc: close.quizava})}
                            }}
                            style={{ textDecoration: 'none', color: 'black' }}
                        >
                            <p>All</p> 
                        </Link>
                        <Link 
                            to="/gallery" 
                            //onClick={() => {if (window.location.href === 'http://localhost:3000/onlinecategory') {window.location.reload()} }}
                            state = {{
                                data: { majorevents: "waterfalls", abt: "" } 
                            }}
                            style={{ textDecoration: 'none', color: 'black' }}
                        >
                            <p>Waterfalls</p> 
                        </Link>
                        <Link 
                            to="/gallery" 
                            //onClick={() => {if (window.location.href === 'http://localhost:3000/onlinecategory') {window.location.reload()} }}
                            state = {{
                                data: { majorevents: "nature walk", abt: "" } 
                            }}
                            style={{ textDecoration: 'none', color: 'black' }}
                        >
                            <p>Nature Walk</p>
                        </Link>
                        <Link 
                            to="/gallery" 
                            //onClick={() => {if (window.location.href === 'http://localhost:3000/onlinecategory') {window.location.reload()} }}
                            state = {{
                                data: { majorevents: "damsite", abt: "" } 
                            }}
                            style={{ textDecoration: 'none', color: 'black' }}
                        >
                            <p>Damsite</p>
                        </Link>
                        <Link 
                            to="/gallery" 
                            //onClick={() => {if (window.location.href === 'http://localhost:3000/onlinecategory') {window.location.reload()} }}
                            state = {{
                                data: { majorevents: "activities", abt: "" } 
                            }}
                            style={{ textDecoration: 'none', color: 'black' }}
                        >
                            <p>Activities</p>
                        </Link>
                        <Link 
                            to="/gallery" 
                            //onClick={() => {if (window.location.href === 'http://localhost:3000/onlinecategory') {window.location.reload()} }}
                            state = {{
                                data: { majorevents: "team building", abt: "" } 
                            }}
                            style={{ textDecoration: 'none', color: 'black' }}
                        >
                            <p>Team Building</p>
                        </Link>
                        
                        
                    </div>

                </div>
            </div>
        </div>
    </>
  );
    
}

export default Gallerymenu;